"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hexToRgba = exports.spacing = void 0;
var tslib_1 = require("tslib");
var HEXADECIMAL_BASE = 16;
var UNIT_BASE = 8;
function decimalToHexadecimal(value) {
    return parseInt(value, HEXADECIMAL_BASE);
}
function spacing(unit) {
    if (unit === void 0) { unit = 1; }
    return "".concat(UNIT_BASE * unit, "px");
}
exports.spacing = spacing;
function hexToRgba(hexColor, opacity) {
    var _a, _b;
    if (opacity === void 0) { opacity = 1; }
    var twoLettersRegex = /\w\w/g;
    var _c = tslib_1.__read((_b = (_a = hexColor.match(twoLettersRegex)) === null || _a === void 0 ? void 0 : _a.map(decimalToHexadecimal)) !== null && _b !== void 0 ? _b : [], 3), r = _c[0], g = _c[1], b = _c[2];
    return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(opacity, ")");
}
exports.hexToRgba = hexToRgba;
